<template>
  <div
    :class="[styles, clearable == false ? 'left-border' : '', 'custom-select']"
  >
    <label v-if="label">{{ label }}</label>
    <v-select
      :placeholder="placeholder"
      :class="[label ? 'h-select' : '', 'select']"
      :options="options"
      label="name"
      :selectHeight="10"
      @input="input"
      :value="value"
      :multiple="multi"
      :clearable="clearable"
      :loading="loading"
      :disabled="disabled"
      :append-to-body="appendToBody"
    >
      <template #spinner="{ loading }">
        <div
          v-if="loading"
          style="border-left-color: rgba(88,151,251,0.71)"
          class="vs__spinner"
        ></div>
      </template>
    </v-select>
    <p class="error m-0" v-if="error">
      {{ error }}
    </p>
  </div>
</template>

<script>
export default {
  name: "Select",
  props: {
    multi: Boolean,
    options: Array,
    name: String,
    label: String,
    value: [String, Number, Object, Array],
    input: Function,
    placeholder: String,
    styles: String,
    clearable: {
      type: Boolean,
      default: undefined
    },
    error: String,
    handleClose: Function,
    loading: Boolean,
    disabled: Boolean,
    appendToBody: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style>
.custom-select .h-select {
  margin-top: 6px;
}
.custom-select {
  min-width: 250px;
}
.select input {
  cursor: pointer;
}
.custom-select label {
  width: 100%;
  font-weight: 500;
  font-size: var(--fs-sm);
  line-height: 1.4;
  color: var(--muted);
  font-family: var(--font-sans);
}
.custom-select .vs__search {
  padding: 0 8px 4px;
  font-family: var(--font-sans);
  font-size: var(--fs-body);
  color: var(--text);
}
.custom-select .vs__dropdown-toggle {
  padding: 0;
  height: 36px;
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
  background: var(--surface);
  transition: border-color var(--dur) var(--ease),
    box-shadow var(--dur) var(--ease);
}
.custom-select .vs--open .vs__dropdown-toggle {
  border-color: var(--accent-600);
  box-shadow: var(--ring);
}
.left-border .vs__actions {
  cursor: pointer;
  padding: 4px 12px 0 12px;
  border-left: 1px solid var(--line);
}
.custom-select .vs__actions svg {
  fill: var(--muted-soft);
}
.custom-select .vs__selected-options {
  overflow: hidden;
}
.custom-select .vs__selected-options input {
  font-size: var(--fs-body);
  line-height: 20px;
  color: var(--text);
  font-family: var(--font-sans);
}
.custom-select .vs__selected-options span {
  font-size: var(--fs-body);
  line-height: 20px;
  color: var(--text);
  font-family: var(--font-sans);
}
.custom-select .vs__selected {
  color: var(--text);
  font-size: var(--fs-body);
  font-family: var(--font-sans);
}
.custom-select .v-select.drop-up.vs--open .vs__dropdown-toggle {
  border-radius: 0 0 var(--radius-md) var(--radius-md);
  border-top-color: transparent;
  border-bottom-color: var(--line-strong);
}

.custom-select [data-popper-placement="top"] {
  border-radius: var(--radius-md) var(--radius-md) 0 0;
  border-top-style: solid;
  border-bottom-style: none;
  box-shadow: var(--shadow-md);
}
.vs__dropdown-menu {
  z-index: 10000001 !important;
  max-height: 220px !important;
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
  background: var(--surface);
  box-shadow: var(--shadow-md), 0 12px 32px rgba(26, 19, 54, 0.16);
  padding: 4px 0;
}
.vs__dropdown-menu li {
  font-size: var(--fs-body);
  line-height: 1.4;
  color: var(--text);
  font-family: var(--font-sans);
  padding: 7px 12px;
}
.vs__dropdown-option--highlight {
  background: var(--accent-050) !important;
  color: var(--accent-600) !important;
}
.vs__dropdown-option--selected {
  background: var(--accent-050);
  color: var(--accent-600);
  font-weight: 500;
}
.custom-select .vs__clear svg {
  fill: var(--muted-soft);
}
.custom-select .vs__spinner {
  border-left-color: var(--accent-600) !important;
}
.custom-select .vs--disabled .vs__dropdown-toggle {
  background: var(--surface-2);
  cursor: not-allowed;
}
</style>
